import React, {useEffect} from "react";
import {Helmet} from "react-helmet";
import $ from 'jquery';
import jQuery from 'jquery';
import './Components/jquery-imports-setup';
import {NavBar} from "./Components/NavBar";
import {Footer} from "./Components/Footer";
import {BasicImportCss} from "./Components/BasicImportCss";


export const HomeLager = (effect, deps) => {

    // useEffect(() => {
    //     require('./Components/jquery-imports-setup');
    // }, []);

    return (<React.Fragment>

        <BasicImportCss/>

        <div className="wrapper" style={{display: "none"}}>

            <NavBar/>

            <section className="header-content">

                <div className="clearifx">

                    <div className="owl-slider">

                        <div className="item"
                             style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/gallery-2.jpg"}}>
                            <div className="box box-left">
                                <div className="text-right">
                                    <h2 className="title animated h1" data-animation="fadeInDown">eCommerce
                                        template</h2>
                                    <div className="animated" data-animation="fadeInUp">
                                        Score new arrivals from latest electronics
                                        <br/>
                                        Multipurpose Ecommerce template ready
                                    </div>
                                    <div className="animated" data-animation="fadeInUp">
                                        <a href="#" target="_blank" className="btn btn-clean"><i
                                            className="icon icon-cart"></i> Buy</a>
                                        <a href="#" target="_blank" className="btn btn-clean"><i
                                            className="icon icon-eye"></i> Details</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item"
                             style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/gallery-3.jpg"}}>
                            <div className="box box-right">
                                <div className="text-left">
                                    <h2 className="title animated h1" data-animation="fadeInDown">Buy this template</h2>
                                    <div className="animated" data-animation="fadeInUp">
                                        Inovative responsive design, with easy customization! <br/>
                                        Purchase now and get free updates
                                    </div>
                                    <div className="animated" data-animation="fadeInUp">
                                        <a href="#" target="_blank" className="btn btn-clean"><i
                                            className="icon icon-cart"></i> Buy</a>
                                        <a href="#" target="_blank" className="btn btn-clean"><i
                                            className="icon icon-eye"></i> Details</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <section className="blog blog-block blog-intro">

                <div className="container">


                    <header className="hidden">
                        <div className="row">
                            <div className="col-md-offset-2 col-md-8 text-center">
                                <h2 className="title">Check out our featured news</h2>
                                <div className="text">
                                    <p>Keeping things minimal</p>
                                </div>
                            </div>
                        </div>
                    </header>

                    <div className="row row-clean">


                        <div className="col-xs-6 col-sm-3">
                            <article>
                                <a href="products-grid.html">
                                    <div className="image">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/project-1.jpg"}
                                             alt=""/>
                                    </div>
                                    <div className="entry entry-block">
                                        <div className="date">2018 Collection</div>
                                        <div className="title">
                                            <h2 className="h3">Fashion</h2>
                                        </div>
                                        <div className="description">
                                            <p>
                                                Top picks four your desire
                                            </p>
                                        </div>
                                    </div>
                                    <div className="show-more">
                                        <span className="btn btn-clean">Shop now</span>
                                    </div>
                                </a>
                            </article>
                        </div>


                        <div className="col-xs-6 col-sm-3">
                            <article>
                                <a href="products-grid.html">
                                    <div className="image">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/project-2.jpg"}
                                             alt=""/>
                                    </div>
                                    <div className="entry entry-block">
                                        <div className="date">New arrivals</div>
                                        <div className="title">
                                            <h2 className="h3">Electronics</h2>
                                        </div>
                                        <div className="description">
                                            <p>
                                                Explore popular devices
                                            </p>
                                        </div>
                                    </div>
                                    <div className="show-more">
                                        <span className="btn btn-clean">Shop now</span>
                                    </div>
                                </a>
                            </article>
                        </div>


                        <div className="col-xs-6 col-sm-3">
                            <article>
                                <a href="products-grid.html">
                                    <div className="image">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/project-3.jpg"}
                                             alt=""/>
                                    </div>
                                    <div className="entry entry-block">
                                        <div className="date">Up to 50% off</div>
                                        <div className="title">
                                            <h2 className="h3">Sporting goods</h2>
                                        </div>
                                        <div className="description">
                                            <p>
                                                Available for quick shipping
                                            </p>
                                        </div>
                                    </div>
                                    <div className="show-more">
                                        <span className="btn btn-clean">Shop now</span>
                                    </div>
                                </a>
                            </article>
                        </div>


                        <div className="col-xs-6 col-sm-3">
                            <article>
                                <a href="products-grid.html">
                                    <div className="image">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/project-4.jpg"}
                                             alt=""/>
                                    </div>
                                    <div className="entry entry-block">
                                        <div className="date">Save big on</div>
                                        <div className="title">
                                            <h2 className="h3">Home & garden</h2>
                                        </div>
                                        <div className="description">
                                            <p>
                                                Fun to explore
                                            </p>
                                        </div>
                                    </div>
                                    <div className="show-more">
                                        <span className="btn btn-clean">Shop now</span>
                                    </div>
                                </a>
                            </article>
                        </div>

                    </div>


                    <div className="wrapper-more">
                        <a href="ideas.html" className="btn btn-lg">View all categories</a>
                    </div>

                </div>

            </section>
            <section className="blog blog-block">


                <header className="hidden">
                    <div className="text-center"><h2 className="title">Categories</h2></div>
                </header>

                <div className="row row-clean">


                    <div className="col-md-6">
                        <article>
                            <div>
                                <div className="image">


                                    <img src={process.env.PUBLIC_URL + "/lager/assets/images/shop-1.jpg"} alt=""
                                         className="hidden-xs"/>


                                    <img src={process.env.PUBLIC_URL + "/lager/assets/images/shop-1-mobile.jpg"} alt=""
                                         className="visible-xs"/>

                                </div>
                                <div className="entry entry-block">
                                    <div className="date">Shop for</div>
                                    <div className="title">
                                        <h2 className="h3">Electronics</h2>
                                    </div>
                                    <div className="description">
                                        <ul>
                                            <li>
                                                <a href="">Computers &amp; tablets</a>
                                            </li>
                                            <li>
                                                <a href="">Cameras &amp; photo</a>
                                            </li>
                                            <li>
                                                <a href="">TV, audio &amp; surveillance</a>
                                            </li>
                                            <li>
                                                <a href="">Cell phones &amp; accessories</a>
                                            </li>
                                            <li className="more">
                                                <a href="#">More</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-md-6">
                        <article>
                            <div>
                                <div className="image">


                                    <img src={process.env.PUBLIC_URL + "/lager/assets/images/shop-2.jpg"} alt=""
                                         className="hidden-xs"/>


                                    <img src={process.env.PUBLIC_URL + "/lager/assets/images/shop-2-mobile.jpg"} alt=""
                                         className="visible-xs"/>

                                </div>
                                <div className="entry entry-block">
                                    <div className="date">Shop for</div>
                                    <div className="title">
                                        <h2 className="h3">Home, Furniture & Appliances</h2>
                                    </div>
                                    <div className="description">
                                        <ul className="col">
                                            <li>
                                                <a href="#">Vacuums & Floor Care</a>
                                            </li>
                                            <li>
                                                <a href="#">Washers & Dryers</a>
                                            </li>
                                            <li>
                                                <a href="#">Refrigerators</a>
                                            </li>
                                            <li>
                                                <a href="#">Dishwashers</a>
                                            </li>
                                            <li className="more">
                                                <a href="#">More</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>

                </div>

            </section>
            <section className="owl-icons-wrapper">


                <header className="hidden">
                    <div className="text-center"><h2 className="title">Product categories</h2></div>
                </header>

                <div className="clearfix">

                    <div className="owl-icons owl-icons-rounded owl-icons-frontpage">


                        <a href="#">
                            <figure>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-1.png"}
                                     alt="Alternate Text"/>
                                <figcaption>Shoes</figcaption>
                            </figure>
                        </a>


                        <a href="#">
                            <figure>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-2.png"}
                                     alt="Alternate Text"/>
                                <figcaption>Gadgets</figcaption>
                            </figure>
                        </a>


                        <a href="#">
                            <figure>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-3.png"}
                                     alt="Alternate Text"/>
                                <figcaption>TV & Video</figcaption>
                            </figure>
                        </a>


                        <a href="#">
                            <figure>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-4.png"}
                                     alt="Alternate Text"/>
                                <figcaption>Drones</figcaption>
                            </figure>
                        </a>


                        <a href="#">
                            <figure>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-5.png"}
                                     alt="Alternate Text"/>
                                <figcaption>Cameras</figcaption>
                            </figure>
                        </a>


                        <a href="#">
                            <figure>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-6.png"}
                                     alt="Alternate Text"/>
                                <figcaption>Mobile phones</figcaption>
                            </figure>
                        </a>


                        <a href="#">
                            <figure>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-7.png"}
                                     alt="Alternate Text"/>
                                <figcaption>Accessories</figcaption>
                            </figure>
                        </a>


                        <a href="#">
                            <figure>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-8.png"}
                                     alt="Alternate Text"/>
                                <figcaption>Home</figcaption>
                            </figure>
                        </a>


                        <a href="#">
                            <figure>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-9.png"}
                                     alt="Alternate Text"/>
                                <figcaption>Projectors</figcaption>
                            </figure>
                        </a>


                    </div>

                </div>

            </section>
            <section className="products">


                <header>
                    <div className="row">
                        <div className="col-md-offset-2 col-md-8 text-center">
                            <h2 className="title">Best seller</h2>
                            <div className="text">
                                <p>Check out our latest collections</p>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="row row-clean">


                    <div className="col-xs-6 col-sm-4 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-7.png"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Coffee machine</a>
                                    </h2>
                                    <sub>$ 159,-</sub>
                                    <sup>$ 139,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <span className="label label-danger">-50%</span>
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-8.png"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Iron set</a>
                                    </h2>
                                    <sub>$ 1999,-</sub>
                                    <sup>$ 1499,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-9.png"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Projector 4k</a>
                                    </h2>
                                    <sub>$ 1999,-</sub>
                                    <sup>$ 1499,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <span className="label label-info">-20%</span>
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-10.png"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Headphones Wireless</a>
                                    </h2>
                                    <sub>$ 1999,-</sub>
                                    <sup>$ 1499,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-11.png"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Vacuum cleaner</a>
                                    </h2>
                                    <sub>$ 1999,-</sub>
                                    <sup>$ 1499,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-12.png"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">E-shaver 500</a>
                                    </h2>
                                    <sub>$ 1999,-</sub>
                                    <sup>$ 1499,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>

                </div>


                <div className="wrapper-more">
                    <a href="products-grid.html" className="btn btn-lg">View all</a>
                </div>


                <div className="popup-main mfp-hide" id="productid1">


                    <div className="product">


                        <div className="popup-title">
                            <div className="h1 title">
                                Headphones Wireless
                                <small>product category</small>
                            </div>
                        </div>


                        <div className="owl-product-gallery">
                            <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-10.png"} alt=""
                                 width="640"/>
                            <img src={process.env.PUBLIC_URL + "/lager/assets/images/product-10a.png"} alt=""
                                 width="640"/>
                        </div>


                        <div className="popup-content">
                            <div className="product-info-wrapper">
                                <div className="row">


                                    <div className="col-sm-6">
                                        <div className="info-box">
                                            <strong>Maifacturer</strong>
                                            <span>Brand name</span>
                                        </div>
                                        <div className="info-box">
                                            <strong>Materials</strong>
                                            <span>Wood, Leather, Acrylic</span>
                                        </div>
                                        <div className="info-box">
                                            <strong>Availability</strong>
                                            <span><i className="fa fa-check-square-o"></i> in stock</span>
                                        </div>
                                    </div>


                                    <div className="col-sm-6">
                                        <div className="info-box">
                                            <strong>Available Colors</strong>
                                            <div className="product-colors clearfix">
                                                <span className="color-btn color-btn-red"></span>
                                                <span className="color-btn color-btn-blue checked"></span>
                                                <span className="color-btn color-btn-green"></span>
                                                <span className="color-btn color-btn-gray"></span>
                                                <span className="color-btn color-btn-biege"></span>
                                            </div>
                                        </div>
                                        <div className="info-box">
                                            <strong>Choose size</strong>
                                            <div className="product-colors clearfix">
                                                <span className="color-btn color-btn-biege">S</span>
                                                <span className="color-btn color-btn-biege checked">M</span>
                                                <span className="color-btn color-btn-biege">XL</span>
                                                <span className="color-btn color-btn-biege">XXL</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>


                        <div className="popup-table">
                            <div className="popup-cell">
                                <div className="price">
                                    <span className="h3">$ 1999,00 <small>$ 2999,00</small></span>
                                </div>
                            </div>
                            <div className="popup-cell">
                                <div className="popup-buttons">
                                    <a href="product.html"><span className="icon icon-eye"></span> <span
                                        className="hidden-xs">View more</span></a>
                                    <a href="#"><span className="icon icon-cart"></span> <span
                                        className="hidden-xs">Buy</span></a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>


            </section>
            <section className="blog blog-block">


                <header className="hidden">
                    <div className="text-center"><h2 className="title">Fashion</h2></div>
                </header>

                <div className="row row-clean">


                    <div className="col-sm-4">
                        <article>
                            <div>
                                <div className="image">
                                    <img src={process.env.PUBLIC_URL + "/lager/assets/images/shop-3.jpg"} alt=""/>
                                </div>
                                <div className="entry entry-block">
                                    <div className="date">Shop for</div>
                                    <div className="title">
                                        <h2 className="h3">Woman's</h2>
                                    </div>
                                    <div className="description">
                                        <ul>
                                            <li>
                                                <a href="#">New arrivals</a>
                                            </li>
                                            <li>
                                                <a href="#">Doscount sale collection</a>
                                            </li>
                                            <li className="more">
                                                <a href="#">More</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-sm-4">
                        <article>
                            <div>
                                <div className="image">
                                    <img src={process.env.PUBLIC_URL + "/lager/assets/images/shop-4.jpg"} alt=""/>
                                </div>
                                <div className="entry entry-block">
                                    <div className="date">Shop for</div>
                                    <div className="title">
                                        <h2 className="h3">Man's</h2>
                                    </div>
                                    <div className="description">
                                        <ul className="col">
                                            <li>
                                                <a href="#">New arrivals</a>
                                            </li>
                                            <li>
                                                <a href="#">Doscount sale collection</a>
                                            </li>
                                            <li className="more">
                                                <a href="#">More</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-sm-4">
                        <article>
                            <div>
                                <div className="image">
                                    <img src={process.env.PUBLIC_URL + "/lager/assets/images/shop-5.jpg"} alt=""/>
                                </div>
                                <div className="entry entry-block">
                                    <div className="date">Shop for</div>
                                    <div className="title">
                                        <h2 className="h3">Kids</h2>
                                    </div>
                                    <div className="description">
                                        <ul className="col">
                                            <li>
                                                <a href="#">New arrivals</a>
                                            </li>
                                            <li>
                                                <a href="#">Doscount sale collection</a>
                                            </li>
                                            <li className="more">
                                                <a href="#">More</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>

                </div>

            </section>
            <section className="products">


                <header>
                    <div className="row">
                        <div className="col-md-offset-2 col-md-8 text-center">
                            <h2 className="title">Clothing & Shoes</h2>
                            <div className="text">
                                <p>Check out our latest collections</p>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="row row-clean">


                    <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">

                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/cloth-1.jpg"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Elegant shoe</a>
                                    </h2>
                                    <sub>$ 199,-</sub>
                                    <sup>$ 99,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/cloth-2.jpg"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Polo shirt</a>
                                    </h2>
                                    <sub>$ 159,-</sub>
                                    <sup>$ 129,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <span className="label label-warning">New</span>
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/cloth-3.jpg"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">T-shirt</a>
                                    </h2>
                                    <sup>$ 29,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite added">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/cloth-4.jpg"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Winter Jacket</a>
                                    </h2>
                                    <sup>$ 299,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <span className="label label-info">-50%</span>
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/cloth-5.jpg"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Sweater</a>
                                    </h2>
                                    <sub>$ 49,-</sub>
                                    <sup>$ 19,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                        <article>
                            <div className="info">
                            <span className="add-favorite">
                                <a href="#" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                            </div>
                            <div className="btn btn-add">
                                <i className="icon icon-cart"></i>
                            </div>
                            <div className="figure-grid">
                                <div className="image">
                                    <a href="#productid1" className="mfp-open">
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/cloth-6.jpg"} alt=""
                                             width="360"/>
                                    </a>
                                </div>
                                <div className="text">
                                    <h2 className="title h5">
                                        <a href="product.html">Lether jacket</a>
                                    </h2>
                                    <sup>$ 499,-</sup>
                                    <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>


                <div className="wrapper-more">
                    <a href="products-grid.html" className="btn btn-lg">View store</a>
                </div>
            </section>
            <section className="blog blog-block">


                <header className="hidden">
                    <div className="text-center"><h2 className="title">Banner</h2></div>
                </header>

                <div className="row row-clean">


                    <div className="col-lg-6">
                        <article>
                            <div>
                                <div className="image">
                                    <img src={process.env.PUBLIC_URL + "/lager/assets/images/cat-1.jpg"} alt=""/>
                                </div>
                                <div className="entry entry-block">
                                    <div className="date">Shop for</div>
                                    <div className="title">
                                        <h2 className="h3">Boxing & MMA Equipment</h2>
                                    </div>
                                    <div className="description">
                                        <ul>
                                            <li>
                                                <a href="#">New arrivals</a>
                                            </li>
                                            <li>
                                                <a href="#">Doscount sale collection</a>
                                            </li>
                                            <li className="more">
                                                <a href="#">More</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>


                    <div className="col-lg-6">
                        <article>
                            <div>
                                <div className="image">
                                    <img src={process.env.PUBLIC_URL + "/lager/assets/images/cat-2.jpg"} alt=""/>
                                </div>
                                <div className="entry entry-block">
                                    <div className="date">Shop for</div>
                                    <div className="title">
                                        <h2 className="h3">Fitness, Running & Yoga Equipment</h2>
                                    </div>
                                    <div className="description">
                                        <ul className="col">
                                            <li>
                                                <a href="#">New arrivals</a>
                                            </li>
                                            <li>
                                                <a href="#">Doscount sale collection</a>
                                            </li>
                                            <li className="more">
                                                <a href="#">More</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>


                </div>

            </section>
            <section className="stretcher-wrapper">


                <header>
                    <div className="row">
                        <div className="col-md-offset-2 col-md-8 text-center">
                            <h1 className="h2 title">Premium watches</h1>
                            <div className="text">
                                <p>Give the gift of polished punctuality</p>
                            </div>
                        </div>
                    </div>
                </header>


                <ul className="stretcher">


                    <li className="stretcher-item"
                        style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/shop-6.jpg"}}>

                        <div className="stretcher-logo">
                            <div className="text">
                                <span className="text-intro">Man's</span>
                            </div>
                        </div>

                        <figure>
                            <h4>Man's watches</h4>
                            <figcaption>Collection of prestigious, high precision timepieces</figcaption>
                        </figure>

                        <a href="#">Anchor link</a>
                    </li>


                    <li className="stretcher-item"
                        style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/shop-7.jpg"}}>

                        <div className="stretcher-logo">
                            <div className="text">
                                <span className="text-intro">Woman's</span>
                            </div>
                        </div>

                        <figure>
                            <h4>Womans's watches</h4>
                            <figcaption>Choose among a wonderful variety of refined and feminine timepieces</figcaption>
                        </figure>

                        <a href="#">Anchor link</a>
                    </li>


                    <li className="stretcher-item"
                        style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/shop-8.jpg"}}>

                        <div className="stretcher-logo">
                            <div className="text">
                                <span className="text-intro">Professional</span>
                            </div>
                        </div>

                        <figure>
                            <h4>Professional watches</h4>
                            <figcaption>Discover your favourite model by combining materials</figcaption>
                        </figure>

                        <a href="#">Anchor link</a>
                    </li>


                    <li className="stretcher-item"
                        style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/shop-9.jpg"}}>

                        <div className="stretcher-logo">
                            <div className="text">
                                <span className="text-intro">Diamond bezzels</span>
                            </div>
                        </div>

                        <figure>
                            <h4>Diamond bezzels</h4>
                            <figcaption>Diamond bezel watch collection of luxurious pieces</figcaption>
                        </figure>

                        <a href="#">Anchor link</a>
                    </li>


                    <li className="stretcher-item more">
                        <div className="more-icon">
                            <span data-title-show="Show more" data-title-hide="+"></span>
                        </div>
                        <a href="#"></a>
                    </li>

                </ul>
            </section>
            <section id="page-interiors" className="cards">


                <header>
                    <div className="row">
                        <div className="col-md-offset-2 col-md-8 text-center">
                            <h2 className="title">Home accessories</h2>
                            <div className="text">
                                <p>Get premium performance compromises!</p>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="row row-clean">


                    <div className="col-md-8">
                        <figure>
                            <figcaption
                                style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/block-1.png"}}>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/blog-1.jpg"} alt=""/>
                            </figcaption>
                            <a href="#interiorId1" className="btn btn-clean mfp-open mfp-open-scrollto">Mobile
                                phones</a>
                        </figure>
                    </div>


                    <div className="col-md-4">
                        <figure>
                            <figcaption
                                style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/block-2.png"}}>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/block-2.png"} alt=""/>
                            </figcaption>
                            <a href="#interiorId1" className="btn btn-clean mfp-open mfp-open-scrollto">Home
                                accessories</a>
                        </figure>
                    </div>


                    <div className="col-md-4">
                        <figure>
                            <figcaption
                                style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/block-3.png"}}>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/block-3.png"} alt=""/>
                            </figcaption>
                            <a href="#interiorId1" className="btn btn-clean mfp-open mfp-open-scrollto">Smart TV</a>
                        </figure>
                    </div>


                    <div className="col-md-4">
                        <figure>
                            <figcaption
                                style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/block-4.png"}}>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/block-4.png"} alt=""/>
                            </figcaption>
                            <a href="#interiorId1" className="btn btn-clean mfp-open mfp-open-scrollto">Chairs</a>
                        </figure>
                    </div>


                    <div className="col-md-4">
                        <figure>
                            <figcaption
                                style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/block-5.png"}}>
                                <img src={process.env.PUBLIC_URL + "/lager/assets/images/block-5.png"} alt=""/>
                            </figcaption>
                            <a href="#interiorId1" className="btn btn-clean mfp-open mfp-open-scrollto">Gaming</a>
                        </figure>
                    </div>


                </div>


                <div className="wrapper-more">
                    <a href="products-grid.html" className="btn btn-lg">View more</a>
                </div>
            </section>
            <section className="blog blog-widget blog-animation">


                <header>
                    <div className="row">
                        <div className="col-md-offset-2 col-md-8 text-center">
                            <h1 className="h2 title">Blog</h1>
                            <div className="text">
                                <p>Latest news from the blog</p>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="container">

                    <div className="row">


                        <div className="col-sm-3">
                            <article>
                                <a href="article.html">
                                    <div className="image"
                                         style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/blog-1.jpg"}}>
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/blog-1.jpg"} alt=""/>
                                    </div>
                                    <div className="entry entry-table">
                                        <div className="date-wrapper">
                                            <div className="date">
                                                <span>MAR</span>
                                                <strong>08</strong>
                                                <span>2017</span>
                                            </div>
                                        </div>
                                        <div className="title">
                                            <h2 className="h5">Turn off the lights before bed with one word</h2>
                                        </div>
                                    </div>
                                </a>
                            </article>
                        </div>


                        <div className="col-sm-3">
                            <article>
                                <a href="article.html">
                                    <div className="image"
                                         style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/blog-2.jpg"}}>
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/blog-2.jpg"} alt=""/>
                                    </div>
                                    <div className="entry entry-table">
                                        <div className="date-wrapper">
                                            <div className="date">
                                                <span>MAR</span>
                                                <strong>03</strong>
                                                <span>2017</span>
                                            </div>
                                        </div>
                                        <div className="title">
                                            <h2 className="h5">Lock the front door when you head to work</h2>
                                        </div>
                                    </div>
                                </a>
                            </article>
                        </div>


                        <div className="col-sm-3">
                            <article>
                                <a href="article.html">
                                    <div className="image"
                                         style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/blog-3.jpg"}}>
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/blog-3.jpg"} alt=""/>
                                    </div>
                                    <div className="entry entry-table">
                                        <div className="date-wrapper">
                                            <div className="date">
                                                <span>MAR</span>
                                                <strong>01</strong>
                                                <span>2017</span>
                                            </div>
                                        </div>
                                        <div className="title">
                                            <h2 className="h5">Get a notification when your kids walk in the door</h2>
                                        </div>
                                    </div>
                                </a>
                            </article>
                        </div>


                        <div className="col-sm-3">
                            <article>
                                <a href="article.html">
                                    <div className="image"
                                         style={{backgroundImage: process.env.PUBLIC_URL + "/lager/assets/images/blog-4.jpg"}}>
                                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/blog-4.jpg"} alt=""/>
                                    </div>
                                    <div className="entry entry-table">
                                        <div className="date-wrapper">
                                            <div className="date">
                                                <span>MAR</span>
                                                <strong>01</strong>
                                                <span>2017</span>
                                            </div>
                                        </div>
                                        <div className="title">
                                            <h2 className="h5">Wake up to a warm cup of coffee</h2>
                                        </div>
                                    </div>
                                </a>
                            </article>
                        </div>

                    </div>

                </div>


                <div className="wrapper-more">
                    <a href="blog-grid.html" className="btn btn-lg">View all posts</a>
                </div>

            </section>
            <section className="banner">


                <h2 className="hidden">Banner</h2>

                <div className="container">
                    <div className="row">
                        <div className="col-md-offset-2 col-md-8 text-center">
                            <h2 className="title">Our story</h2>
                            <p>
                                We believe in creativity as one of the major forces of progress. With this idea, we
                                traveled throughout Italy to find exceptional
                                artisans and bring their unique handcrafted objects to connoisseurs everywhere.
                            </p>
                            <p>
                                <a href="about.html" className="btn btn-clean">Read full story</a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="instagram">


                <header>
                    <h2 className="h3 title">
                        Follow us<br/>
                        <i className="fa fa-instagram fa-3x"></i> <br/>
                        Instagram
                    </h2>
                    <div className="text">
                        <p>@LagerShop</p>
                    </div>
                </header>


                <div className="gallery clearfix">
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-1.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-2.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-3.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-4.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-5.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-6.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-7.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-8.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-9.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-10.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-11.jpg"} alt="Alternate Text"/>
                    </a>
                    <a className="item" href="#">
                        <img src={process.env.PUBLIC_URL + "/lager/assets/images/square-12.jpg"} alt="Alternate Text"/>
                    </a>
                </div>


            </section>

            <Footer/>

        </div>

    </React.Fragment>);
}